import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {getEmployee} from "../../actions/employee";
import {useParams, useHistory, useLocation} from 'react-router-dom';
import {Col, Nav, Row, Tab} from 'react-bootstrap'
import GoBackButton from "../layout/GoBackButton";
import EmployeeAbout from "./tabs/EmployeeAbout";
import EmployeeTransactions from "./tabs/EmployeeTransactions";
import EmployeeBaseRate from "./tabs/EmployeeBaseRate";

const EmployeePage = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const {id} = useParams();

    const {employee, employee_transactions} = useSelector(state => state.employee);

    // Get current tab from URL
    const getCurrentTab = () => {
        const path = location.pathname;
        if (path.includes('/about')) return 'about';
        if (path.includes('/transactions')) return 'transactions';
        if (path.includes('/salary-rates')) return 'salary-rates';
        return 'about'; // default tab
    };

    const [activeTab, setActiveTab] = useState(getCurrentTab());

    useEffect(() => {
        dispatch(getEmployee(id));
    }, [dispatch, id]);

    // Update tab when URL changes
    useEffect(() => {
        setActiveTab(getCurrentTab());
    }, [location.pathname]);

    // Redirect base employee URL to about tab
    useEffect(() => {
        if (location.pathname === `/employees/${id}`) {
            history.replace(`/employees/${id}/about`);
        }
    }, [location.pathname, id, history]);

    // Handle tab change and update URL
    const handleTabChange = (tabKey) => {
        setActiveTab(tabKey);
        
        // Update URL based on tab
        let newPath = `/employees/${id}`;
        switch (tabKey) {
            case 'about':
                newPath += '/about';
                break;
            case 'transactions':
                newPath += '/transactions';
                break;
            case 'salary-rates':
                newPath += '/salary-rates';
                break;
            default:
                newPath += '/about';
        }
        
        history.push(newPath);
    };

    return (
        <div>
            <div className="content mt-0 pt-0">
                <div className="container-fluid p-0">

                    <div className="row mb-2">
                        <div className="col-md-12 col-lg-8">
                            <h1 className="h3 mb-3">
                                <strong>{employee?.first_name} {employee?.last_name}</strong> sahifasi </h1>
                        </div>
                        <div className="col-lg-4">
                            <div className="crud_actions text-end">
                                <GoBackButton/>
                            </div>
                        </div>
                    </div>


                    <div className="row">

                        <div className="card px-4 py-3">
                            <Tab.Container id="left-tabs-example" activeKey={activeTab} onSelect={handleTabChange}>
                                <Row>
                                    <Col sm={3} md={3}>
                                        <Nav variant="pills" className="flex-column">
                                            <Nav.Item>
                                                <Nav.Link eventKey="about"
                                                          className="text-center fw-bold">Haqida</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="transactions"
                                                          className="text-center fw-bold">Hisob-kitob</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="salary-rates"
                                                          className="text-center fw-bold">Ish haqi</Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                    </Col>
                                    <Col sm={9} md={9}>
                                        <Tab.Content>
                                            <Tab.Pane eventKey="about">

                                                <EmployeeAbout employee={employee}/>

                                            </Tab.Pane>

                                            <Tab.Pane eventKey="transactions">

                                                <EmployeeTransactions employee={employee}
                                                                      employee_transactions={employee_transactions}/>

                                            </Tab.Pane>

                                            <Tab.Pane eventKey="salary-rates">

                                                <EmployeeBaseRate employee={employee}/>

                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Col>
                                </Row>
                            </Tab.Container>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    );
};

export default EmployeePage;